<script>
  import { userProfileStore } from "../../store.js";
  import { supabase } from "../../auth.js";
  import { onMount } from "svelte";
  import Modal from "../../components/Modal.svelte";
  import OpenFormButton from "../../components/OpenProfileFormButton.svelte";
  import UserAvatar from "../../components/UserAvatar.svelte";
  import Icon from "svelte-awesome";
  import { youtubePlay, instagram, spotify } from "svelte-awesome/icons";

  const fetchProfile = async () => {
    const { body } = await supabase
      .from("users")
      .select("*")
      .eq("id", supabase.auth.user().id);
    $userProfileStore = body[0];
  };

  onMount(fetchProfile);
</script>

<Modal>
  <OpenFormButton />
</Modal>

<div
  class="p-10 my-6 text-gray-800 break-all bg-gray-50 bg-opacity-90 rounded-3xl"
>
  <div class="flex items-center mb-10">
    <div
      class="flex items-center justify-center mr-5 rounded-full bg-gradient-to-r w-28 h-28 from-fcred to-white"
    >
      <UserAvatar userAvatarUrl={$userProfileStore.avatar_url} />
    </div>
    <div>
      <h1 class="text-4xl">{$userProfileStore.name}</h1>
      <h2 class="text-xl text-gray-600">{$userProfileStore.slogan}</h2>
    </div>
  </div>

  <p>
    {$userProfileStore.description}
  </p>
</div>

<div class="flex flex-wrap md:space-x-10">
  <div class="w-full p-10 my-6 bg-gray-50 md:flex-1 bg-opacity-90 rounded-3xl">
    <h1>Termine</h1>
    <h2>Bundesliga:</h2>
    <p>Do, 24.02. 18:30: Bayer Leverkusen : 1. FC Köln</p>
  </div>
  <div class="w-full p-10 my-6 bg-gray-50 md:flex-1 bg-opacity-90 rounded-3xl">
    <div class="flex flex-col justify-around">
      <a href={$userProfileStore.youtube_url}>
        <div class="flex items-center hover:text-fcred">
          <Icon class="w-6 text-fcred" data={youtubePlay} />
          <p class="px-2">Youtube</p>
        </div>
      </a>
      <a href={$userProfileStore.instagram_url}>
        <div class="flex items-center hover:text-fcred">
          <Icon class="w-6 text-fcred" data={instagram} />
          <p class="px-2">Instagram</p>
        </div>
      </a>
      <a href={$userProfileStore.spotify_url}>
        <div class="flex items-center hover:text-fcred">
          <Icon class="w-6 text-fcred" data={spotify} />
          <p class="px-2">Spotify</p>
        </div>
      </a>
    </div>
  </div>
</div>

<style type="text/scss">
</style>
